import React, { Component } from 'react';
import { graphql } from 'gatsby';
import Helmet from 'react-helmet';
import DevelopmentTeams from 'views/developmentTeams';
import Layout from 'components/layout';
import { NavBar, PopupRedirect } from 'components';
import { pages } from 'config/pages';
import config from '../../meta/config';

class DTPage extends Component {
  render() {
    const page = pages['development-teams'];
    const { navColors } = page;
    const canonical = `${config.siteUrl}/development-teams/`;

    const { data } = this.props;
    const { allArticles } = data || {};

    return (
      <Layout {...{page, canonical}}>
        <Helmet title="Development Teams">
          <meta
            name={'description'}
            content={
              'Boldare’s Development Teams can extend your in-house team or become your remote product development department.'
            }
          />
          <link rel="canonical" href={canonical} />
        </Helmet>
        <NavBar color={navColors} />
        <PopupRedirect />
        <DevelopmentTeams allArticles={allArticles} />
      </Layout>
    );
  }
}

export const pageQuery = graphql`
  query DTQuery {
    allArticles: allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___settings___date] }
      filter: {
        frontmatter: {
          title: {
            in: [
              "Visualising Energy"
              "How to scale a monolithic MVP application without losing business?"
              "From design to development in 4 weeks. Creating a mobile and web MVP for an iconic brand"
            ]
          }
        }
      }
    ) {
      ...markdownFields
      ...boxMarkdownFields
    }
  }
`;

export default DTPage;
